var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"banner-slide",style:(_vm.bannerStyle)},_vm._l((_vm.homeBanner),function(item,index){return _c('img',{key:index,staticClass:"banner-img",attrs:{"src":item.url,"alt":item.alt},on:{"click":function($event){return _vm.imgClick(item.destination);}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1e01232","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = null
// module chunks = 